Vue.asyncComponent('ak-text-localized', {
    props: {
        label: {
            type: String,
            required: false,
        },
        text: {
            type: Object,
            required: true,
        },
    },
    computed: {
        /**
         * Get the current text width the active locale
         * @return {*}
         */
        currentText() {
            return this.text[this.$localeHandler.getActiveLocale()];
        }
    }
}, 'layout/ak-text-localized.html');